<script>
import {mapActions} from "vuex";

export default {
  name: "FileItem",
  props: ["document"],
  data: () => ({
    loading: false,
  }),
  methods: {
    ...mapActions('einspeisebeteiligung', ['downloadFile']),
    async onDownload() {
      this.loading = true;

      try {
        await this.downloadFile(this.document.osid);
      } finally {
        this.loading = false;
      }
    }
  },
}
</script>

<template>
  <v-sheet elevation="1" class="my-3 pa-2" style="display: flex">
    <div class="year-container">
      <div>{{ document.jahr}}</div>
    </div>
    <div class="px-2" style="flex-grow: 1; display: flex; align-items: center">
      <p class="primary-text font-weight-bold mb-1">{{ document.dokumenttyp }} {{ document.jahr }}</p>
    </div>
    <div class="d-flex flex-column justify-end">
      <v-btn icon color="primary" @click="onDownload" :loading="loading">
        <v-icon>$download</v-icon>
      </v-btn>
    </div>
  </v-sheet>
</template>

<style scoped>
.year-container {
  width: 116px;
  height: 116px;
  background: transparent linear-gradient(45deg, #8C0F78 0%, #B40055 100%) 0% 0% no-repeat padding-box;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.year-container div {
  color: #F59BAF;
  font-size: 30px;
  font-weight: bold;
}
</style>
